import axios from "axios";
import { Gift } from "lucide-react";
import { toast } from "sonner";

import { itensDoCupom } from "../novo-pedido-regras/itensDoCupom";

import { premioCabeNaSacola, premioComoCupom } from "./premios";
import useCartaoFidelidade from "./useCartaoFidelidade";

/**
 * Totem e Balcão: com o cliente identificado, mostra os carimbos dele e o
 * prêmio a usar. "Usar" aplica o prêmio como o cupom do carrinho
 * (`useDescontoBalcao`): no prêmio de produto, o produto precisa estar no
 * carrinho. O servidor confere tudo de novo ao gravar o pedido.
 */
export default function PremioNoBalcao({ cliente, canal, carrinho, desconto }) {
  const { estado, premios } = useCartaoFidelidade(cliente?.id, canal, { autenticado: true });
  if (!estado) return null;
  const c = estado.cartao || {};
  const aplicado = desconto?.desconto?.tipo === "coupon" ? desconto.desconto.cupom?.code : null;

  const usar = async (p) => {
    const cupom = premioComoCupom(p, estado.soma_cashback);
    if (!premioCabeNaSacola(cupom, carrinho)) {
      toast.error(`Coloque ${p.texto.replace(/ grátis$/, "")} no carrinho para usar o prêmio.`);
      return;
    }
    try {
      const total = (carrinho || []).reduce((s, i) => s + Number(i.final_price ?? i.sale_price ?? 0) * Number(i.quantity || 1), 0);
      const { data } = await axios.post("/api/coupons/validate", {
        code: p.codigo, order_total: total, customer_id: cliente.id, customer_phone: cliente.telefone || null,
        items: itensDoCupom(carrinho || []), modulo: canal,
      });
      if (!data?.valid) { toast.error(data?.error || data?.message || "O prêmio não vale neste pedido"); return; }
      desconto.setDesconto({ tipo: "coupon", valor: 0, cupom: { ...data, code: p.codigo } });
      toast.success(`Prêmio aplicado: ${p.texto}`);
    } catch {
      toast.error("Não foi possível aplicar o prêmio agora");
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-e2e="premio-balcao">
      {c.participa && (
        <span className="rounded-full px-3 py-1.5 text-sm font-semibold text-white" title="Cartão fidelidade"
          style={{ background: `linear-gradient(135deg, ${estado.loja?.tema?.c1}, ${estado.loja?.tema?.c2})` }}>
          {estado.loja?.tema?.emoji} {c.carimbos}/{c.total} carimbos
        </span>
      )}
      {premios.map((p) => (
        <button key={p.codigo} type="button" onClick={() => usar(p)} disabled={aplicado === p.codigo}
          className="flex items-center gap-2 rounded-full bg-amber-500/15 border border-amber-500/40 px-3 py-1.5 text-sm font-semibold text-amber-300 active:scale-95 transition-transform disabled:opacity-70">
          <Gift className="w-4 h-4" /> {aplicado === p.codigo ? `Prêmio aplicado: ${p.texto}` : `Usar prêmio: ${p.texto}`}
        </button>
      ))}
    </div>
  );
}
